var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fe3d30;}.cls-2{fill:none;stroke:#333e49;stroke-miterlimit:10;stroke-width:3.03px;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RED"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 455.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 439.97,
    y1: 682.16,
    x2: 439.97,
    y2: 682.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M694.92,564c2.72-9.06,5.16-20,7.11-30,3.7-19-1.48-38.76-14.76-52.78a178.34,178.34,0,0,0-129.75-56.07h-115a178.4,178.4,0,0,0-129.76,56.06c-13.27,14-18.45,33.81-14.75,52.76,2,10,4.41,21,7.14,30.07a15.24,15.24,0,0,0,14.59,10.87h.11c36.41,0,69.72-7.53,95.48-20a18.19,18.19,0,0,0,10.26-16.38V522.71a18.17,18.17,0,0,1,18.17-18.18H556.25a18.17,18.17,0,0,1,18.17,18.18v15.75a18.19,18.19,0,0,0,10.26,16.38c25.76,12.51,59.11,20,95.51,20h.15A15.23,15.23,0,0,0,694.92,564Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/endCall.7302cdafd78fedbf86eca9490358afe8.svg";
export { ForwardRef as ReactComponent };